import { useState } from 'react';
import { FiMail, FiUser, FiMessageSquare, FiSend, FiCheckCircle } from 'react-icons/fi';
import { api } from '../api/client';

function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const update = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError('Please fill in all required fields.');
      return;
    }

    setSending(true);
    try {
      await api.post('/v1/contact', form);
      setSent(true);
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <main className="sections contact-page">
        <div className="contact-success-card">
          <FiCheckCircle className="contact-success-icon" />
          <h2>Message Sent!</h2>
          <p>Thank you for reaching out. We&apos;ll get back to you as soon as possible.</p>
          <button
            type="button"
            className="contact-btn"
            onClick={() => setSent(false)}
          >
            Send Another Message
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="sections contact-page">
      <header className="contact-header">
        <h1>Contact Us</h1>
        <p>Have a question or feedback? We&apos;d love to hear from you.</p>
      </header>

      <div className="contact-card">
        <form className="contact-form" onSubmit={handleSubmit}>
          {error ? <p className="contact-error" role="alert">{error}</p> : null}

          <div className="contact-row">
            <div className="contact-field">
              <label htmlFor="contact-name">
                <FiUser className="contact-field-icon" />
                Name <span className="contact-req">*</span>
              </label>
              <input
                id="contact-name"
                type="text"
                placeholder="Your name"
                value={form.name}
                onChange={update('name')}
                required
              />
            </div>
            <div className="contact-field">
              <label htmlFor="contact-email">
                <FiMail className="contact-field-icon" />
                Email <span className="contact-req">*</span>
              </label>
              <input
                id="contact-email"
                type="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={update('email')}
                required
              />
            </div>
          </div>

          <div className="contact-field">
            <label htmlFor="contact-subject">
              <FiMessageSquare className="contact-field-icon" />
              Subject
            </label>
            <input
              id="contact-subject"
              type="text"
              placeholder="What is this about?"
              value={form.subject}
              onChange={update('subject')}
            />
          </div>

          <div className="contact-field">
            <label htmlFor="contact-message">
              <FiMessageSquare className="contact-field-icon" />
              Message <span className="contact-req">*</span>
            </label>
            <textarea
              id="contact-message"
              rows="6"
              placeholder="Write your message here..."
              value={form.message}
              onChange={update('message')}
              required
            />
          </div>

          <button
            type="submit"
            className="contact-btn contact-btn--submit"
            disabled={sending}
          >
            {sending ? 'Sending...' : (
              <>
                <FiSend />
                Send Message
              </>
            )}
          </button>
        </form>
      </div>
    </main>
  );
}

export default ContactPage;
